// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BarChart_wrapper__3fpdz","content":"BarChart_content__19A69","subtitle":"BarChart_subtitle__1qnbo"};